(ns minorodata.connections.sources.mysql
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "mysql"
   :name         "MySQL"
   :description  "The world's most popular open source database. Supports MySQL version 8.0.0 and higher."
   :image-source "mysql.png"
   :tags         ["data-import"]
   :message-queue-enabled true
   :enabled      true

   :preview-formatter
   (fn [source]
     (str "DB: "
          (get-in source [:source-db-creds :dbname])
          ", server: "
          (get-in source [:source-db-creds :host])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [port user password extra dbname hostname name description
                    bastion-hostname bastion-user bastion-port private-key
                    has-bastion?]} data]
        {:source-type "mysql"
         :name        name
         :description description

         :source
         (cond-> {:source-db-creds {:dbtype   "mysql"
                                    :host     hostname
                                    :port     port
                                    :user     user
                                    :password password
                                    :extra    extra
                                    :dbname   dbname}}

           (and has-bastion?
                (every? some? [bastion-hostname
                               bastion-user]))
           (assoc :bastion {:host     bastion-hostname
                            :user     bastion-user
                            :port     bastion-port
                            :db-host  hostname
                            :private-key private-key}))}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [source-db-creds bastion]} source
            {:keys [host user port db-host private-key]} bastion
            source-host  (:host source-db-creds)
            has-bastion? (if (every? some? [host user port])
                           true
                           false)]
        (merge (select-keys source-db-creds [:port :user :password :extra :dbname])
               {:bastion-hostname host
                :bastion-user     user
                :bastion-port     port
                :private-key      private-key
                :hostname         (or db-host source-host)
                :name             name
                :description      description
                :has-bastion?     has-bastion?})))

    :validate (constantly nil)

    :id :mysql-form

    :blocks [{:content "Supports MySQL version 8.0.0 and higher"}

             {:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Hostname"
              :name       :hostname
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Port"
              :name       :port
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database User"
              :name       :user
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database Password"
              :name       :password
              :type       :password
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Database Name"
              :name       :dbname
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Extra Parameters"
              :name       :extra
              :value      ""}

             {:block-type :checkbox
              :label      "Requires tunneling"
              :name       :has-bastion?
              :type       :checkbox
              :value      false}

             {:block-type :subtitle
              :content    "Bastion host"
              :conditions [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion Hostname"
              :name          :bastion-hostname
              :required      true
              :value         ""
              :default-value ""
              :conditions [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion User"
              :name          :bastion-user
              :value         ""
              :default-value ""
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}
             
             {:block-type    :input
              :label         "Bastion Port"
              :name          :bastion-port
              :value         "22"
              :default-value "22"
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type :file-input
              :label      "Private key file"
              :name       :private-key
              :required   true
              :type       :password
              :conditions [[:eq [:has-bastion? :value] true]]}


             {:block-type      :api-connection-test
              :name            :api-connection-test
              :dbtype          "mysql"
              :connection-type :db}


             {:block-type :submit
              :content    "SAVE"}]}



   :extract-form
   {:format-for-api
    (fn [{:keys [name description status
                 source-schema source-table columns
                 update-column extract-type unique-columns
                 destination-table action raw-binary-mode]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [(app.utils/keep-non-nil-keys
                    {:action            action
                     :schema            source-schema
                     :table             source-table
                     :source-table      (str source-schema "." source-table)
                     :extract-type      extract-type
                     :destination-table destination-table
                     :columns           columns
                     :update-column     (when (= "incremental" extract-type)
                                          update-column)
                     :unique-columns    unique-columns
                     :raw-binary-mode   raw-binary-mode})]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config source-id]} data

            extract (get-in config [:extracts 0])

            {:keys [columns source-table raw-binary-mode schema table]} extract

            [_ schema table] (if (and schema table)
                               ["" schema table]
                               (re-matches #"(.*?)\.(.*)" (or source-table "")))]

        (merge
         (select-keys extract [:action :destination-table :extract-type :update-column :unique-columns :raw-binary-mode])
         {:raw-binary-mode (or raw-binary-mode false)}
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :source-id     source-id

           :source-schema schema
           :source-table  table

           :columns (if (some? columns)
                      columns
                      [])}))))

    :validate (constantly nil)

    :id :mysql-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract configuration"}

             {:block-type :form-value
              :name       :source-id}

             {:block-type :database-metadata-select
              :label      "Schema"
              :loading-text "Loading schemas..."
              :disabled-text "Select schema"
              :empty-option-text "No schemas available"
              :required   true
              :value      ""
              :name       :source-schema

              :fetch-type      :schemas

              :options-sub     :connections.subs/database-schemas
              :upstream-deps   []
              :downstream-deps [:source-table :update-column :columns :unique-columns]}


             {:block-type :database-metadata-select
              :label      "Table"
              :loading-text "Loading tables..."
              :disabled-text "Select table"
              :empty-option-text "Select valid schema first"
              :required   true
              :value      ""
              :name       :source-table

              :fetch-type   :tables
              :schema-field :source-schema

              :options-sub     :connections.subs/database-tables
              :upstream-deps   [:source-schema]
              :downstream-deps [:update-column :unique-columns]}


             {:block-type :database-metadata-select
              :label      "Columns"
              :loading-text "Loading columns..."
              :disabled-text "Select columns"
              :empty-option-text "Select valid table first"

              :required   true
              :multiple   true

              :value      []
              :name       :columns

              :select-all         true
              :select-all-options :connections.subs/database-columns

              :fetch-type   :columns
              :schema-field :source-schema
              :table-field  :source-table

              :options-sub      :connections.subs/database-columns
              :options-meta-sub :connections.subs/database-columns-with-metadata
              :upstream-deps    [:source-schema :source-table]
              :downstream-deps  []}

             {:block-type :database-metadata-select
              :label      "Unique primary key column(s)"
              :loading-text "Loading columns..."
              :disabled-text "Select columns"
              :empty-option-text "Select column"
              :value      []
              :name       :unique-columns

              :select-all         true
              :select-all-options :connections.subs/database-primary-keys

              :multiple   true

              :fetch-type   :primary-keys
              :schema-field :source-schema
              :table-field  :source-table

              :options-sub     :connections.subs/database-columns
              :upstream-deps   [:source-schema :source-table]
              :downstream-deps []}

             {:content   "Please specify a column or several columns that contain(s) unique values for each row. This is to ensure that there is no missing data."}

             {:block-type :checkbox
              :label      "Store binary columns as raw binary"
              :name       :raw-binary-mode
              :type       :checkbox
              :value      false
              :doc        [:span "When enabled, binary/blob columns (LONGBLOB, BLOB, BINARY, VARBINARY, ...) are stored as their exact original bytes in the warehouse (Snowflake BINARY, BigQuery BYTES) instead of being converted to text. No data is lost either way. Leave off unless these columns hold non-text binary data: any text stored in a blob column will land as binary and need converting back (e.g. Snowflake TO_VARCHAR) to read as text."]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}


             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Incremental" :value "incremental"}
                           {:name "Full"        :value "backfill"}]
              :required   true
              :value      nil}

             {:block-type :database-metadata-select
              :label      "Incremental column"
              :loading-text "Loading columns..."
              :disabled-text "Select column"
              :empty-option-text "Select column"
              :value      ""
              :name       :update-column
              :required   true

              :skip-request    true
              :options-sub     :connections.subs/database-columns
              :upstream-deps   [:source-schema :source-table]
              :downstream-deps []
              :conditions      [[:eq [:extract-type :value] "incremental"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
